module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"header":{"name":"項目","current_reward":"現在の報酬","max_reward":"最大報酬"},"footer":{"name":"合計"}}}')
  delete Component.options._Ctor
}
